import api from "./api";

const get = async () => await api.get('province/')
const getCities = async (provinceId) => await api.get(`province/${provinceId}/city`)

export default {get,getCities}
